module.exports = __webpack_public_path__ + "static/media/webdesign-services-img4.12426d54.jpg";